import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly IDLE_TIME = 60 * 60 * 1000 * 12; // 12 hours in milliseconds
  private idleTimeout: any;
  private activitySubscription?: Subscription;
  private isMonitoring = false;

  private logoutSubject = new Subject<void>();
  public logout$ = this.logoutSubject.asObservable();

  private activityEvents$ = merge(
    fromEvent(document, 'mousedown'),
    fromEvent(document, 'mousemove'),
    fromEvent(document, 'keypress'),
    fromEvent(document, 'scroll'),
    fromEvent(document, 'touchstart'),
    fromEvent(document, 'click')
  );

  constructor(
    private router: Router
  ) {}

  public startMonitoring(): void {
    if (this.isMonitoring) {
      return;
    }

    this.isMonitoring = true;
    
    this.resetIdleTimer();

    this.activitySubscription = this.activityEvents$.pipe(
      debounceTime(1000)
    ).subscribe(() => {
      this.resetIdleTimer();
    });
  }

  public stopMonitoring(): void {
    this.isMonitoring = false;
    
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
      this.idleTimeout = null;
    }

    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
      this.activitySubscription = undefined;
    }
  }

  private resetIdleTimer(): void {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }

    this.idleTimeout = setTimeout(() => {
      this.autoLogout();
    }, this.IDLE_TIME);
  }

  private autoLogout(): void {
    this.stopMonitoring();
    this.logoutSubject.next();
    this.router.navigate(['/login']);
  }
}
